function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.39103 9.75591C1.1789 9.75576 0.975514 9.67136 0.825598 9.52128C0.675683 9.3712 0.591513 9.16772 0.591599 8.95559L0.596024 1.03599C0.596175 0.823855 0.680572 0.620469 0.830655 0.470554C0.980738 0.320638 1.18422 0.236468 1.39635 0.236555L10.9159 0.241874C11.021 0.241786 11.1251 0.262458 11.2221 0.302702C11.3192 0.342947 11.4073 0.401971 11.4815 0.476384L14.3083 3.30639C14.7582 3.75673 15.0107 4.36732 15.0103 5.00384C15.01 5.64036 14.7568 6.25067 14.3065 6.7005L11.4764 9.52735C11.3315 9.67208 11.1312 9.76135 10.9106 9.76123L1.39103 9.75591Z",
  fill: "currentColor"
});

function SvgBadgeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIcon);
export default __webpack_public_path__ + "static/media/badge-icon.41219695.svg";
export { ForwardRef as ReactComponent };